import { Box } from '../common/ui';
export default function ColorBlob() {
  return (
    <Box>
      <Box
        sx={{
          width: 486,
          height: 486,
          borderRadius: 9999,
          backgroundColor: 'accent1',
          position: 'absolute',
          top: -10,
          right: -345,
          filter: 'blur(65px)',
          mixBlendMode: 'multiply',
        }}
      />
      <Box
        sx={{
          width: 430,
          height: 430,
          borderRadius: 9999,
          backgroundColor: 'accent2',
          position: 'absolute',
          top: 122,
          right: -345,
          filter: 'blur(65px)',
          mixBlendMode: 'multiply',
        }}
      />
    </Box>
  );
}
